import { uuid } from '../utils';
import {
  ANIMATION
} from './categories';

export default {
  id: uuid(),
  priority: 0,
  name: 'Love Me, Fear Me',
  thumbnail: './LMFM/LMFM-Thumb.jpg',
  categories: [ ANIMATION ],
  content: [
    'https://vimeo.com/448617702',
    'https://vimeo.com/454693987',
    './LMFM/Fool_loop.gif',
    './LMFM/Rebirth.gif'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/lmfm.js